import React from 'react';
import PropTypes from "prop-types";
import ReactVideoModal from "../ReactVideoModal/ReactVideoModal";
import './ReactVideoInline.scss';

const ReactVideoInline = (props) => (
    <ReactVideoModal uri={props.uri} inlineAlt/>
);

ReactVideoInline.propTypes = {
    uri: PropTypes.string.isRequired,
};

export default ReactVideoInline;



// WEBPACK FOOTER //
// ./frontend/components/ReactVideoInline/ReactVideoInline.jsx